import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { WarehouseInfo } from "../types";

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  warehouseToDelete: WarehouseInfo | null;
}

/**
 * 削除確認モーダル
 */
export default function DeleteConfirmDialog({
  open,
  onClose,
  onConfirm,
  warehouseToDelete, // 削除対象の倉庫情報
}: DeleteConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>削除確認</DialogTitle>
      <DialogContent>
        <Box p={2}>
          <Typography variant="body1">
            倉庫「{warehouseToDelete?.depot_name}」を削除します。本当によろしいですか？
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="custom-outlined">
          キャンセル
        </Button>
        <Button onClick={onConfirm} variant="contained" color="secondary">
          削除
        </Button>
      </DialogActions>
    </Dialog>
  );
}
